import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import bannerService from '../../services/banner';

const initialState = {
  loading: false,
  banners: [],
  allBanners: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchBanners = createAsyncThunk(
  'banner/fetchBanners',
  (params = {}) => {
    return bannerService
      .getPaginate({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

export const fetchAllBanners = createAsyncThunk(
  'banner/fetchAllBanners',
  (params = {}) => {
    return bannerService
      .getAll({ limit: 500, ...params })
      .then((res) => res);
  }
);

const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchBanners.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchBanners.fulfilled, (state, action) => {
      const { payload } = action;
      const pagination = payload?.pagination ?? {};
      const meta = payload?.meta ?? {
        current_page: pagination.page,
        per_page: pagination.perPage,
        total: pagination.total,
        last_page: pagination.lastPage,
      };
      state.loading = false;
      state.banners = payload?.data ?? [];
      state.meta = {
        ...meta,
        lastPage: meta.last_page ?? pagination.lastPage ?? meta.lastPage,
      };
      state.params.page = meta.current_page ?? pagination.page ?? state.params.page;
      state.params.perPage = meta.per_page ?? pagination.perPage ?? state.params.perPage;
      state.error = '';
    });
    builder.addCase(fetchBanners.rejected, (state, action) => {
      state.loading = false;
      state.banners = [];
      state.error = action.error.message;
    });
    builder.addCase(fetchAllBanners.fulfilled, (state, action) => {
      const { payload } = action;
      state.allBanners = payload?.data ?? [];
    });
  },
});

export default bannerSlice.reducer;
